import { render, staticRenderFns } from "./helperRomePopover.vue?vue&type=template&id=635eff06&scoped=true"
import script from "./helperRomePopover.vue?vue&type=script&lang=js"
export * from "./helperRomePopover.vue?vue&type=script&lang=js"
import style0 from "./helperRomePopover.vue?vue&type=style&index=0&id=635eff06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635eff06",
  null
  
)

export default component.exports